<template>
  <div class="ehf-emoji-list" :class="{ 'is-mobile': isMobileDevice }">
    <template v-if="objMode">
      <span v-for="item in emojiList" :key="item.id" class="ehf-emoji-item" :class="{ active: item.is_interact == 1 }" @click="selectEmoji(item)">
        {{ item.content }}
      </span>
    </template>
    <template v-else>
      <span v-for="(item, i) in emojiList" :key="i" class="ehf-emoji-item" @click="selectEmoji(item)">{{ item }}</span>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'EhfEmojiList',
  }
</script>

<script setup>
  import { computed, toRefs, ref } from 'vue'
  import { checkIsMobileDevice } from '@/utils'

  const emit = defineEmits(['select'])
  const isMobileDevice = ref(checkIsMobileDevice()) //是否移动端

  const props = defineProps({
    list: {
      type: Array,
      default() {
        return null
      },
    },
    objMode: {
      type: Boolean,
      default: false,
    },
  })
  const { list, objMode } = toRefs(props)
  const emojiList = computed(() => {
    if (list.value) {
      // 传入指定emoji
      return list.value
    } else {
      // 默认emoji
      return [
        '☀',
        '🌃',
        '🌅',
        '🌈',
        '🌟',
        '⌛',
        '⏰',
        '🍀',
        '🍃',
        '🌻',
        '🌿',
        '🍎',
        '😍',
        '🙌',
        '🙏',
        '💲',
        '💰',
        '🔥',
        '🎀',
        '🎁',
        '🎅',
        '🎄',
        '🎈',
        '🎉',
        '🎊',
        '☎',
        '📲',
        '📩',
        '📪',
        '📢',
        '📣',
        '📦',
        '📍',
        '📖',
        '📔',
        '📕',
        '📗',
        '📘',
        '📙',
        '📚',
        '📜',
        '📈',
        '📒',
        '🏆',
        '🚗',
        '🚚',
        '🚒',
        '🚨',
        '🎯',
        '💌',
        '💎',
        '🔺',
        '🔻',
        '⭕',
        '❌',
        '❗',
        '❓',
        '❕',
        '💓',
        '❤',
        '💖',
        '💚',
        '💙',
        '🚩',
        '✔',
        '🉑',
        '➕',
        '💡',
        '💪',
        '✨',
        '💫',
        '🔴',
        '🔵',
        '⭐',
        '🔶',
        '🔷',
        '💯',
        '🔔',
        '✌',
        '👋',
        '👆',
        '👇',
        '👉',
        '👈',
        '👍',
        '👏',
        '👌',
        '🛒',
        '🥇',
        '🏅',
        '🎖',
      ]
    }
  })
  const selectEmoji = (item) => {
    emit('select', item)
  }
</script>

<style lang="scss" scoped>
  .ehf-emoji-list {
    display: flex;
    flex-wrap: wrap;
    user-select: none;
    &.is-mobile {
      .ehf-emoji-item {
        font-size: 6vw !important;
        width: 9vw !important;
        height: 9vw !important;
        border-radius: 1.2vw !important;
      }
    }
    .ehf-emoji-item {
      width: 30px;
      height: 30px;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      margin-right: 4px;
      cursor: pointer;
      font-family: 'Segoe UI Emoji', 'Segoe UI Symbol', 'Segoe UI', 'Apple Color Emoji', 'Twemoji Mozilla', 'Noto Color Emoji', 'Android Emoji';
      &:hover {
        background-color: #f3f4f6;
      }
      &.active {
        background-color: #ddf4ff;
      }
    }
  }
</style>
